// eslint-disable-next-line simple-import-sort/imports
import ChangePasswordForm from '@/pages/user-settings/log-in/components/ChangePasswordForm';
import './index.css';

export default function AdminPasswordChange() {
  return (
    <div className="welcome-admin__container">
      <ChangePasswordForm />
    </div>
  );
}
